<template>
  <div class="phone-form">
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item prop="phone">
        <!--对手机号码进行修改-->
        <div class="input phone">
          <div class="name-box">{{ phoneTypeTxt }}</div>
          <template>
            <div class="input-old-phone" v-if="phoneType == 'old'">
              {{ form.phone }}
            </div>
            <el-input v-model="form.phone" v-else></el-input>
          </template>
        </div>
        <!--
        <div class="input phone" v-if="developerInfo.phone">
          <div class="name-box">{{ phoneTypeTxt }}</div>
          <template>
          <div class="input-old-phone" v-if="phoneType=='old'">
              {{ form.phone }}
            </div>
            <el-input v-model="form.phone" v-else></el-input>
          </template>
        </div>  -->
        <!--对手机号码进行首次绑定,暂时屏蔽-->
        <!--
          <div class="input phone" v-else>
             <div class="name-box">{{phoneTypeTxt}}</div>
             <template>
             <div class="input-old-phone" v-if="phoneType=='old'">
              {{ form.phone }}
            </div>
            <el-input v-model="form.phone"  v-else></el-input>
             </template>  
          </div>   -->
      </el-form-item>
      <el-form-item prop="code">
        <div class="input code">
          <el-input v-model="form.code"></el-input>
          <!--获取验证码-->
          <div
            class="btn code"
            :class="{ 'btn-forbid': isDisabled }"
            @click="sendCode"
          >
            {{ codeTxt }}
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="btn btn-next" @click="submitFn">下一步</div>
  </div>
</template>

<script>
//import {getVercode,getKfzInfo}from '@/api/common';
import { getVercode, checkVercode, getKfzInfo } from '@/api/common';
import { changePhone } from '@/api/account';
import { mapState } from 'vuex';
export default {
  name: 'oldPhone',
  data() {
    let checkoutPhone = (rule, value, callback) => {
      let reg =
        /^(13[0-9]|14[01456879]|15[0-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else if (reg.test(value)) {
        callback();
      } else {
        if (this.phoneType === 'old') {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };

    return {
      phoneTypeTxt: '',
      form: {},
      rules: {
        phone: [{ validator: checkoutPhone, trigger: 'blur' }],
        code: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
      },
      codeTxt: '获取验证码',
      isDisabled: false,
      //   phone: 13421390317, // 尤已绑定734676042
      // phone: 13538224239, // 陶未绑定
    };
  },
  props: {
    phoneType: {
      type: String,
      default: 'old',
    },
  },

  mounted() {
    this.init();
  },
  computed: {
    ...mapState(['developerInfo', 'userInfo']),
  },
  methods: {
    init() {
      //判断是否是首次绑定
      if (this.developerInfo.phone) {
        if (this.phoneType == 'old') {
          this.phoneTypeTxt = '原手机号';
          this.form = {
            phone: this.developerInfo.phone,
            code: '',
          };
        } else {
          this.phoneTypeTxt = '新手机号';
          this.form = {
            phone: '',
            code: '',
          };
        }
      } else {
        this.phoneTypeTxt = '手机号';
        this.form = {
          phone: '',
          code: '',
        };
      }
    },
    // 获取公共验证码
    async fetchGetVercode() {
      try {
        await getVercode({
          phone: this.form.phone,
          tk: this.userInfo.tk,
          op: this.phoneType == 'old' ? 2 : 3,
        });
        this.$message.success('发送成功');
        this.countDown();
      } catch (error) {
        console.log(error);
      }
    },
    // 验证验证码
    async fetchCheckVercode() {
      try {
        let res = await checkVercode({ vercode: this.form.code, op: 2 });
        console.log('checkVercode res---', res);
        //跳转到绑定的新号码
        this.$message.success('操作成功');
        this.$router.push({
          name: 'accNewPhone',
          params: {
            way: 'bind',
            ver_id: res.ver_id,
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 提交修改手机申请
    async fetchChangePhone() {
      let data = {
        vercode: this.form.code,
        new_phone: this.form.phone,
        old_phone: this.developerInfo.phone,
        tk: this.userInfo.tk,
        op: 3,
      };
      if (this.$route.params && this.$route.params.ver_id) {
        data.ver_id = this.$route.params.ver_id;
      }
      try {
        await changePhone(data);
        this.$message.success('操作成功');
        this.fetchKfzInfo();
        this.$router.push({
          name: 'accSuccessPhone',
          params: { res: 'success', sucType: 'change' },
        });
        // debugger;
      } catch (error) {
        console.log(error);
      }
    },
    //首次绑定手机号码
    async fetchBindPhone() {
      let data = {
        vercode: this.form.code,
        new_phone: this.form.phone,
        tk: this.userInfo.tk,
      };
      try {
        await changePhone(data);
        this.$message.success('操作成功');
        this.fetchKfzInfo();
        this.$router.push({
          name: 'accSuccessPhone',
          params: { res: 'success' },
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 存储新手机号
    async fetchKfzInfo() {
      try {
        const res = await getKfzInfo();
        this.$store.commit('SET_DEVELOPER_INFO', res.data);
      } catch (error) {
        console.log(error);
      }
    },
    // 区分修改手机新旧手机提交逻辑
    submitFn() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          //首次绑定手机号码
          if (this.developerInfo.phone) {
            this.phoneType == 'old'
              ? this.fetchCheckVercode()
              : this.fetchChangePhone();
          } else {
            this.fetchBindPhone();
          }
        } else {
          return false;
        }
      });
    },
    // 发送验证码
    sendCode() {
      if (this.isDisabled) return;
      this.$refs.form.validateField('phone', errMsg => {
        if (!errMsg) {
          this.fetchGetVercode();
        }
      });
    },
    // 倒计时
    countDown() {
      let time = 60;
      const interId = setInterval(() => {
        time--;
        if (time > 0) {
          this.isDisabled = true;
          this.codeTxt = `重新发送${time}S`;
        } else {
          clearInterval(interId);
          this.isDisabled = false;
          this.codeTxt = '获取验证码';
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

.phone-form {
  .input {
    display: flex;
    justify-content: space-between;
    .phone {
      line-height: normal;
      display: inline-table;
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
    }

    .name-box {
      background-color: #f5f7fa;
      color: #909399;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      padding: 0 20px;
      white-space: nowrap;
      margin-right: -2px;
      height: 40px;
    }
  }

  .btn {
    height: 40px;
    background-color: $--color-primary;
    border-radius: 4px;
    width: 130px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    &:hover {
      filter: brightness(105%);
    }
  }
  .btn.code {
    margin-left: 10px;
  }
  .btn-forbid {
    cursor: not-allowed;
    background: #d9d9d9 !important;
    &:hover {
      filter: brightness(100%);
    }
  }
  .btn-next {
    background-color: $--color-primary;
    height: 40px;
    border-radius: 4px;
    text-align: center;
    color: #fff;
    line-height: 40px;
    width: 100%;
    margin-bottom: 50px;
  }
  .input-old-phone {
    height: 40px;
    background-color: #f5f7fa;
    flex: 1;
    background-color: #f5f7fa;
    color: #909399;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding: 0 20px;
    cursor: not-allowed;
  }
}
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '';
}
</style>
